import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-error-pago',
  templateUrl: './error-pago.component.html',
  styleUrls: ['./error-pago.component.scss'],
})
export class ErrorPagoComponent implements OnInit {
  @Input() imgError: string = '';
  @Input() tipoError: string = '';
  @Input() mensajeError: string = '';
  @Input() textBtn: string = '';
  @Input() numberWp;
  @Input() data: string = '';

  constructor(private modalCtl: ModalController) {}

  cerrarModal(){
    this.modalCtl.dismiss();
  }

  ngOnInit() {
    let url;
    
    if(this.numberWp.includes('https')){
      url = `${this.numberWp}&text=${this.data}`
    }else{
      url = `https://api.whatsapp.com/send?phone=${this.numberWp}&text=Hola, te escribo desde Panaderos del Mundo ${this.data}`
    }
    setTimeout(() => {
      window.open(
        `${url}`,
        '_blank'
      );
    }, 2500);
  }

}
